export default "__VITE_ASSET__DEfHYEjo__"